// "Has anybody actually drawn anything?"
//
// The resolve page's Save and Submit run EVERY mounted markup pane's
// saver, and each save posts the composed canvas to the server as a new
// image version. A pane nobody touched must therefore be able to say so,
// or pressing either button files another copy of a picture the issue
// already has - which is how a submitted issue ended up carrying the same
// screenshot four or five times over.
//
// The question is answered by comparing the MARKUP CONTENT against a
// baseline taken when the document loaded, not by watching for calls to
// the state setters. Watching the setters was tried first and got it
// wrong in the flow that matters most: pasting an image swaps the canvas
// document, several handlers touch state on the way through, and the pane
// then reported itself edited when nobody had drawn a thing - so Submit
// attached the pasted picture a second time.
//
// A content comparison cannot be fooled that way. Incidental state churn
// that leaves the same shapes behind is not an edit; neither is loading a
// different document, nor drawing something and undoing it again.
//
// Markup is PER SHEET: each sheet of a multi-page document keeps its own
// shapes, the one on screen in live state and the rest in the tool's
// stash. The signature spans all of them, so flipping between sheets does
// not read as a change and work drawn on a sheet you have since left
// still counts.

// pageStash: the tool's pageMarkupRef.current — { [page]: {shapes, images} }
// page / liveShapes / liveImages: the sheet on screen right now.
//
// Taken as arguments rather than read from state so a baseline can be
// captured synchronously inside the document-load effect, before the
// setState calls it just made have landed.
export function markupSignature(pageStash, page, liveShapes, liveImages) {
  const pages = {};
  Object.keys(pageStash || {}).forEach((k) => {
    if (Number(k) === Number(page)) return; // superseded by live state
    pages[String(k)] = {
      s: (pageStash[k] && pageStash[k].shapes) || [],
      i: (pageStash[k] && pageStash[k].images) || [],
    };
  });
  pages[String(page)] = { s: liveShapes || [], i: liveImages || [] };
  return JSON.stringify(
    Object.keys(pages)
      .sort((a, b) => Number(a) - Number(b))
      .map((k) => [k, pages[k]])
  );
}

// A null baseline means no document ever finished loading, so there is
// nothing of anyone's to lose by answering "not dirty".
export function isMarkupDirty(baseline, signature) {
  return baseline !== null && baseline !== undefined && signature !== baseline;
}
